module.exports = __webpack_public_path__ + "img/2f_l_tomatsu.32a47386.jpg";